import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Keep the install prompt even if it fires before the login screen mounts
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pgfInstallPrompt = e;
  window.dispatchEvent(new Event("pgf-install-available"));
});
window.addEventListener("appinstalled", () => {
  window.__pgfInstallPrompt = null;
  window.dispatchEvent(new Event("pgf-install-done"));
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
